import Platform from '../Platform'
import Storage from './Storage'

export default class App extends Platform {
  constructor () {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      platform: 'adobe-xd',
      storage: new Storage(global.settings || {}),
      features: {
        localStorage: true,
        prototype: true,
        messages: false,
        vector: true
      }
    })
  }

  async insertItem (file, selection) {
    console.log('insertItem', file)
    if (file.format === 'svg') {
      await global.insertSVG(selection, file)
    } else {
      await global.insertRaster(selection, file)
    }
  }

  async insertItems (files, selection) {
    console.log('insertItems', files)
    if (files[0].format === 'svg') {
      await global.insertSVGs(selection, files)
    } else {
      await global.insertRasters(selection, files)
    }
  }

  openURL (url) {
    require('uxp').shell.openExternal(url)
  }
}
